export default __webpack_public_path__ + "static/media/icon585.87c266e1.svg";